export default button => {

    const toggle = () => {
        if (button.getAttribute('aria-expanded') === 'false') {
            button.setAttribute('aria-expanded', 'true');
            button.setAttribute('aria-describedby', button.getAttribute('aria-controls'));
        } else {
            button.setAttribute('aria-expanded', 'false');
            button.removeAttribute('aria-describedby');
        }
    };

    const init = () => {
        button.addEventListener('click', toggle);
    };

    const destroy = () => {
        button.removeEventListener('click', toggle);
    };

    return {
        init,
        destroy
    };
};
